var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_1443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 16C11.3078 16 13.9893 15.4234 13.9893 14.7121C13.9893 14.0008 11.3078 13.4242 8.00001 13.4242C4.69223 13.4242 2.01074 14.0008 2.01074 14.7121C2.01074 15.4234 4.69223 16 8.00001 16Z",
    fill: "url(#paint0_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9893 14.7121C13.9893 14.0008 11.3078 13.4242 8 13.4242C7.44973 13.4242 6.91699 13.4402 6.41083 13.4701L7.53193 15.1194C7.5632 15.1655 7.59972 15.2049 7.63978 15.2381L8.39881 15.9971C11.5206 15.9529 13.9893 15.3946 13.9893 14.7121Z",
    fill: "url(#paint1_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5645 6.56446C14.5645 2.93901 11.6255 0 8.00006 0C4.39039 0 1.47209 2.88762 1.43588 6.49713C1.40856 9.22325 3.04329 11.5705 5.3887 12.5885C5.78117 12.7588 6.11689 13.0377 6.35742 13.3915L7.53195 15.1194C7.75654 15.4498 8.24348 15.4498 8.46807 15.1194L9.64257 13.3916C9.88235 13.0388 10.2163 12.7597 10.6077 12.5901C12.9357 11.5813 14.5645 9.26325 14.5645 6.56446Z",
    fill: "url(#paint2_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 15.0402C7.96195 15.0402 7.86658 15.03 7.80242 14.9356L6.62793 13.2077C6.35172 12.8013 5.96822 12.4834 5.51891 12.2885C3.21202 11.2871 1.73773 9.01521 1.76295 6.50042C1.77958 4.84156 2.43483 3.28859 3.60797 2.12753C4.78099 0.966584 6.34093 0.327148 7.99997 0.327148H8C11.4393 0.327148 14.2373 3.12523 14.2373 6.56451C14.2373 9.05289 12.7615 11.3003 10.4776 12.29C10.0308 12.4836 9.64854 12.8009 9.37202 13.2077L8.19753 14.9356C8.13337 15.03 8.038 15.0402 7.99997 15.0402Z",
    fill: "url(#paint3_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 10.6908C10.279 10.6908 12.1264 8.84341 12.1264 6.56448C12.1264 4.28555 10.279 2.43811 8.00003 2.43811C5.7211 2.43811 3.87366 4.28555 3.87366 6.56448C3.87366 8.84341 5.7211 10.6908 8.00003 10.6908Z",
    fill: "url(#paint4_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3591 8.19887L10.4387 4.2785C9.82881 3.62814 8.96192 3.22168 7.99997 3.22168C6.15379 3.22168 4.65717 4.71831 4.65717 6.56449C4.65717 7.52643 5.06363 8.39332 5.71398 9.0032L9.84562 13.1348C10.0579 12.9027 10.3169 12.7161 10.6077 12.5901C12.4489 11.7922 13.8525 10.1753 14.3591 8.19887Z",
    fill: "url(#paint5_linear_133_1443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 9.9073C9.84616 9.9073 11.3428 8.41067 11.3428 6.56449C11.3428 4.71831 9.84616 3.22168 7.99997 3.22168C6.15379 3.22168 4.65717 4.71831 4.65717 6.56449C4.65717 8.41067 6.15379 9.9073 7.99997 9.9073Z",
    fill: "url(#paint6_linear_133_1443)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_1443",
    x1: 7.86812,
    y1: 14.1563,
    x2: 8.61212,
    y2: 17.2918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_1443",
    x1: 11.11,
    y1: 15.3081,
    x2: 9.12907,
    y2: 12.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_1443",
    x1: 4.03808,
    y1: 2.60229,
    x2: 17.1361,
    y2: 15.7003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_1443",
    x1: 6.59222,
    y1: 5.1604,
    x2: 1.98943,
    y2: 0.557611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_133_1443",
    x1: 10.4882,
    y1: 9.05264,
    x2: 2.25829,
    y2: 0.822737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_133_1443",
    x1: 12.2929,
    y1: 10.8574,
    x2: 8.64528,
    y2: 7.20979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_133_1443",
    x1: 7.18165,
    y1: 5.31655,
    x2: 9.15699,
    y2: 8.32894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.01669e90711d79c65998bded2cae677c.svg";
export { ForwardRef as ReactComponent };